import type { IsoDate, RouteStop, ScanEstimate, StoredRoute } from '../../../shared/types';
import { dayTitle, scanAsk } from '../logic/daily';
import { btn, linkBtn } from '../ui/components';
import { h, replaceChildren } from '../ui/dom';

export const renderScanAsk = (
  host: HTMLElement,
  head: HTMLElement,
  est: ScanEstimate,
  planAnyway: () => void,
  scan: (area: string) => Promise<void>,
) =>
  replaceChildren(
    host,
    head,
    h('p', { class: 'plan__ask' }, scanAsk(est)),
    h(
      'div',
      { class: 'planbar' },
      linkBtn('Not now', '#/route', { variant: 'ghost' }),
      btn('Plan anyway', {
        variant: 'subtle',
        onClick: planAnyway,
      }),
      btn('Look it up', { variant: 'primary', onClick: () => void scan(est.area) }),
    ),
  );

/** The route he already accepted for the day, on either device, as the sync brought it. */
export const renderAcceptedPlan = (
  host: HTMLElement,
  map: HTMLElement,
  forDay: IsoDate,
  route: StoredRoute,
  stopCard: (stop: RouteStop, i: number, editable: boolean) => HTMLElement,
  planAgain: () => void,
) => {
  replaceChildren(
    host,
    h(
      'div',
      { class: 'planhead' },
      h(
        'div',
        { class: 'planhead__day' },
        [`Accepted for ${dayTitle(forDay)}`, route.area].filter(Boolean).join(' · '),
      ),
    ),
    map,
    h(
      'div',
      { class: 'stops' },
      route.stops.map((st, i) => stopCard(st, i, false)),
    ),
    h(
      'div',
      { class: 'planbar' },
      linkBtn('Back to Route', '#/route', { variant: 'ghost' }),
      btn('Plan again', {
        variant: 'subtle',
        onClick: planAgain,
      }),
    ),
  );
};

export const money = (usd: number) => `$${usd.toFixed(2)}`;

export const monthsAgo = (iso: string | null | undefined): string => {
  const at = iso ? Date.parse(iso) : NaN;
  if (Number.isNaN(at)) return 'a while ago';
  const months = Math.max(1, Math.round((Date.now() - at) / (30 * 86_400_000)));
  return `${months} ${months === 1 ? 'month' : 'months'} ago`;
};
